import { render, staticRenderFns } from "./AssignAddonDialog.vue?vue&type=template&id=11c0b130&scoped=true"
import script from "./AssignAddonDialog.vue?vue&type=script&lang=js"
export * from "./AssignAddonDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignAddonDialog.vue?vue&type=style&index=0&id=11c0b130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c0b130",
  null
  
)

export default component.exports